module.exports = __webpack_public_path__ + "img/aside-right@3x.f067c1b6.png";